export default __webpack_public_path__ + "static/media/architecture-img-14.36ee538d.jpg";